import styled from 'styled-components';
import { ArticleStyleProps } from './types';

export const Root = styled.div<ArticleStyleProps>`
  margin: 0 auto;
  max-width: ${({ $width = '1080px' }) =>
    typeof $width === 'number' ? `${$width}px` : $width};
`;
